const mediaItems = [
  {
    title: '流浪地球3 · 终极预告',
    type: '预告片',
    duration: '02:35',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20scene%20with%20massive%20space%20engine%20and%20earth%2C%20dramatic%20orange%20and%20blue%20lighting%2C%20movie%20trailer%20thumbnail%20style%2C%20dark%20atmosphere%2C%20professional%20film%20frame&width=800&height=450&seq=media-thumb-01&orientation=landscape',
  },
  {
    title: '封神第二部 · 幕后特辑',
    type: '花絮',
    duration: '08:12',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20epic%20Chinese%20fantasy%20film%20with%20crew%20and%20warriors%2C%20golden%20warm%20lighting%2C%20cinematic%20documentary%20style%2C%20dark%20edges%2C%20film%20production%20atmosphere&width=800&height=450&seq=media-thumb-02&orientation=landscape',
  },
  {
    title: '热辣滚烫 · 精彩片段',
    type: '名场面',
    duration: '03:48',
    img: 'https://readdy.ai/api/search-image?query=Emotional%20boxing%20match%20scene%20with%20dramatic%20spotlight%2C%20warm%20golden%20and%20dark%20contrast%2C%20cinematic%20movie%20clip%20thumbnail%2C%20intense%20sports%20moment%2C%20film%20frame%20aesthetic&width=800&height=450&seq=media-thumb-03&orientation=landscape',
  },
  {
    title: '飞驰人生3 · 赛车集锦',
    type: '精彩混剪',
    duration: '05:20',
    img: 'https://readdy.ai/api/search-image?query=Racing%20cars%20on%20desert%20track%20with%20dust%20and%20dramatic%20sunset%20sky%2C%20action%20movie%20clip%20style%2C%20warm%20amber%20lighting%2C%20cinematic%20motion%20blur%2C%20dark%20vignette&width=800&height=450&seq=media-thumb-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-2 h-6 md:h-7 rounded-full bg-accent-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">精彩片段</h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10">热门电影的预告片、花絮与名场面精选</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/40 hover:border-accent-500/30 transition-all cursor-pointer"
            >
              <div className="relative w-full h-[180px] md:h-[200px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-950/20 group-hover:bg-background-950/40 transition-colors flex items-center justify-center">
                  <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-950/60 group-hover:bg-accent-500/90 transition-colors">
                    <i className="ri-play-fill text-background-50 text-xl md:text-2xl ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-foreground-50 text-[10px] font-mono">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2 px-2 py-0.5 rounded bg-accent-500/80 text-background-50 text-[10px] font-medium">
                  {item.type}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-50 group-hover:text-accent-400 transition-colors">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}